export default "__VITE_ASSET__YNOspKfN__"